import * as CryptoJS from 'crypto-js';  

// From https://stackoverflow.com/questions/47891104/compatible-aes-encryption-and-decryption-for-c-sharp-and-javascript

export class EncryptionUtil  {
    
    keySize: number = 256;
    ivSize: number = 128;
    saltSize: number = 256;
    iterations: number = 1000;
    constructor() 
    { 
        
    }
  
    decrypt(transitmessage: any, pass: any) {
        var hexResult = this.base64ToHex(transitmessage);
    
        var salt = CryptoJS.enc.Hex.parse(hexResult.substr(0, 64));
        var iv = CryptoJS.enc.Hex.parse(hexResult.substr(64, 32));
        var encrypted = this.hexToBase64(hexResult.substring(96));
    
        var key = CryptoJS.PBKDF2(pass, salt, {
          keySize: this.keySize / 32,
          iterations: this.iterations,
        });
    
        var decrypted = CryptoJS.AES.decrypt(encrypted, key, {
          iv: iv,
          padding: CryptoJS.pad.Pkcs7,
          mode: CryptoJS.mode.CBC,
        });
    
        return decrypted.toString(CryptoJS.enc.Utf8);
      }
    
      // This results in stack size being exceeded for large input values
      hexToBase64_nogood(str: any) {
        
        return btoa(
          String.fromCharCode.apply(
            null,
            str
              .replace(/\r|\n/g, '')
              .replace(/([\da-fA-F]{2}) ?/g, '0x$1 ')
              .replace(/ +$/, '')
              .split(' ')
          )
        );
      }

      hexToBase64( buffer: any ) {
        buffer = buffer
              .replace(/\r|\n/g, '')
              .replace(/([\da-fA-F]{2}) ?/g, '0x$1 ')
              .replace(/ +$/, '')
              .split(' ')
        
        var binary = '';
        var bytes = new Uint8Array( buffer );
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode( bytes[ i ] );
        }
        return window.btoa( binary );
      }
    
      base64ToHex(str: any) {
        str = str.replace(/"/g, '');
        for (
          var i = 0, bin = atob(str.replace(/[ \r\n]+$/, '')), hex = [];
          i < bin.length;
          ++i
        ) {
          var tmp = bin.charCodeAt(i).toString(16);
          if (tmp.length === 1) tmp = '0' + tmp;
          hex[hex.length] = tmp;
        }
        return hex.join('');
      }
}